import * as React from 'react';
import './Footer.css';



function Footer() {
    return (
        <footer className='footer-magalu'>
            <section className='section-magalu'>
                <p>
                    @2024 Magazine Luiza
                </p>
        </section>
        </footer>    
    );
};
export default Footer
